import { QuestionTypeName } from './LearnwareEnums';
export const LEGACY_QUESTIONTYPENAMES = [
    QuestionTypeName.MultipleChoice,
    QuestionTypeName.CorrectWrong,
    QuestionTypeName.KnowAWord,
    QuestionTypeName.Associate,
    QuestionTypeName.MemorizePoints,
    QuestionTypeName.ThinkAndReveal,
    QuestionTypeName.Vocabulary,
];
export const rewardCategories = {
    Video: 'Lustige Videos',
    Foto: 'Lustige Fotos',
    Witz: 'Witze',
    Besondere: 'Besondere Belohnungen',
};
